import * as Yup from 'yup';

export const planReviewTaskFormSchema = Yup.object().shape({
  conditionedArea: Yup.string().required('ACH Area is required'),
  // volume: Yup.string().required('Volume is required'),
  windowArea: Yup.string().required('Window Area is required'),
  // bluePrint: Yup.string().required('Blueprint is required'),
});
